export { default as makeResponsiveSpacingProps } from './make-responsive-spacing-props'
